export const validateInspectionDataForExport = (data: any[]): boolean => {
  return Array.isArray(data) && data.length > 0
}
